import { createTypedEnum } from '@reckon-web/formschema-enums';

export const ActivityTargetTypeEnum = createTypedEnum({
  0: 'Unknown',
  1: 'Job',
  2: 'Task',
} as const);
export type ActivityTargetValue =
  (typeof ActivityTargetTypeEnum.values)[number];
export type ActivityTargetLabel =
  (typeof ActivityTargetTypeEnum.labels)[number];

export const ActivityCategoryEnum = createTypedEnum({
  // Not a real value
  0: 'Unknown',
  // A Job/Task is Created
  1: 'Created',
  // A field on a job/task is updated
  2: 'FieldUpdated',
  // One or more entities have been removed from a job
  3: 'EntitiesRemoved',
  // One or more entities have been added to a job
  4: 'EntitiesAdded',
  // A Job/task is deleted
  5: 'Deleted',
  // A Job’s recurrence has been changed
  6: 'RecurrenceUpdated',
  // A Job’s recurrence has been removed
  7: 'RecurrenceRemoved',
  // Job sign-off has been requested
  8: 'SignOffRequest',
  // Job sign-off request has been withdrawn
  9: 'SignOffWithdraw',
  // Job sign-off request has been approved
  10: 'SignOffApprove',
  // Job sign-off request has been declined
  11: 'SignOffDecline',
  // Job sign-off request has been revoked
  12: 'SignOffRevoke',
  // Job was closed
  13: 'Closed',
  // Job was reopened
  14: 'Reopened',
} as const);
export type ActivityCategoryEnumValue =
  (typeof ActivityCategoryEnum.values)[number];
export type ActivityCategoryEnumLabel =
  (typeof ActivityCategoryEnum.labels)[number];

export const ActivityPropertyTypeEnum = createTypedEnum({
  // Not a real value
  1: 'Unknown',
  // A primitive string
  2: 'String',
  // A primitive integer
  3: 'Int',
  // A primitive floating point number
  4: 'Float',
  // A primitive boolean value
  5: 'Boolean',
  // A Custom Scalar: Date
  6: 'Date',
  // A Custom Scalar: Money to be formatted as currency
  7: 'Money',
  // A Custom Scalar: Guid identifier for a Type: User
  8: 'User',
  // A Enum: Job Status
  9: 'JobStatus',
  // A Enum: Task Status
  10: 'TaskStatus',
  // A Type: Job Recurrence (json stringified)
  11: 'Recurrence',
  // A list of Custom Scalar: Guid identifiers for Type: Entity objects
  12: 'EntityList',
  // A point in time
  13: 'DateTime',
  // A custom job status type
  14: 'JobStatusType',
} as const);
export type ActivityPropertyTypeEnumValue =
  (typeof ActivityPropertyTypeEnum.values)[number];
export type ActivityPropertyTypeEnumLabel =
  (typeof ActivityPropertyTypeEnum.labels)[number];
